import React, { createContext, useContext, useState } from 'react';

interface IWishlistResultsContext {
  hoveredId: number | null;
  mapHoveredId: number | null;
  updateHoveredId: (id: number | null) => void;
  updateMapHoveredId: (id: number | null) => void;
}
const WishlistResultsContext = createContext<IWishlistResultsContext>({
  hoveredId: null,
  mapHoveredId: null,
  updateHoveredId: () => {
    /**/
  },
  updateMapHoveredId: () => {
    /**/
  },
});

export const useWishlistResultsCtx = () => useContext(WishlistResultsContext);

const WishlistResultsCtx: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  const [mapHoveredId, setMapHoveredId] = useState<number | null>(null);

  return (
    <WishlistResultsContext.Provider
      value={{
        hoveredId,
        mapHoveredId,
        updateHoveredId: setHoveredId,
        updateMapHoveredId: setMapHoveredId,
      }}>
      {children}
    </WishlistResultsContext.Provider>
  );
};

export default WishlistResultsCtx;
